import React from "react";

export interface DotProps extends React.HTMLAttributes<HTMLButtonElement> {}

export const Dot: React.FC<DotProps> = ({ onClick, children, ...rest }) => {
  return (
    <button onClick={onClick} {...rest}>
      {children}
    </button>
  );
};
